import { NgModule } from '@angular/core'
import { DirectiveModule } from '@shared/directives/directive.module'

import { TabNavBarComponent } from './tab-nav-bar.component'
import { SectionComponent } from './section/section.component'
import { SectionMetaComponent } from './section-meta/section-meta.component'
import { SectionToolbarComponent } from './section-toolbar/section-toolbar.component'
import { FormComponent } from '@shared/components/layout/form/form.component'
import { VendorModule } from '@shared/vendor.module'
import { FormSectionsWrapperComponent } from './form/form-sections-wrapper.component'
import { FormSectionComponent } from './form/form-section.component'
import { FormToolbarComponent } from './form/toolbar/form-toolbar.component'
import {
  FormToolbarInfoComponent,
  FormToolbarInfoLabelComponent,
  FormToolbarInfoRowComponent,
  FormToolbarInfoValueComponent,
} from './form/toolbar/form-toolbar-info.component'
import { ReportByVehicleSectionComponent } from './report-by-vehicle-section/report-by-vehicle-section.component'
import { SectionUpdComponent } from './section-upd/section-upd.component'
import { TabNavBarUpdComponent } from './tab-nav-bar-upd/tab-nav-bar-upd.component'

@NgModule({
  declarations: [
    FormComponent,
    FormSectionComponent,
    FormSectionsWrapperComponent,
    FormToolbarComponent,
    FormToolbarInfoComponent,
    FormToolbarInfoLabelComponent,
    FormToolbarInfoRowComponent,
    FormToolbarInfoValueComponent,
    SectionComponent,
    SectionUpdComponent,
    SectionMetaComponent,
    SectionToolbarComponent,
    TabNavBarComponent,
    TabNavBarUpdComponent,
    ReportByVehicleSectionComponent,
  ],
  imports: [VendorModule, DirectiveModule],
  exports: [
    FormComponent,
    FormSectionComponent,
    FormSectionsWrapperComponent,
    FormToolbarComponent,
    FormToolbarInfoComponent,
    FormToolbarInfoLabelComponent,
    FormToolbarInfoRowComponent,
    FormToolbarInfoValueComponent,
    SectionComponent,
    SectionUpdComponent,
    SectionMetaComponent,
    SectionToolbarComponent,
    TabNavBarComponent,
    TabNavBarUpdComponent,
    ReportByVehicleSectionComponent,
  ],
})
export class LayoutModule {}
